// Client-side hydration hook. Replaces the old src/main.tsx.
// See https://vike.dev/onRenderClient
export { onRenderClient };

import type { ComponentType } from "react";
import { hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import type { PageContextClient } from "vike/types";
// Self-hosted brand fonts (no external Google request). Lato drives body/UI,
// while Poppins drives display headings. See tailwind.config.js fontFamily.
import "@fontsource/lato/300.css";
import "@fontsource/lato/400.css";
import "@fontsource/lato/700.css";
import "@fontsource/poppins/700.css";

async function onRenderClient(pageContext: PageContextClient) {
  const Page = pageContext.Page as ComponentType;
  const root = document.getElementById("root");
  if (!root) throw new Error("DOM element #root not found");

  hydrateRoot(
    root,
    <HelmetProvider>
      <BrowserRouter>
        <Page />
      </BrowserRouter>
    </HelmetProvider>,
  );
}
